import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { localize } from '../../../util/Localizer'
import Card from '@material-ui/core/Card'
import NgrxAuth from '../../../auth/Auth'
import Divider from '@material-ui/core/Divider'
import SearchPractitioner from '../../../widgets/SubmitAClaim/searchPractitioner'
import PractitionerRow from '../../../widgets/SubmitAClaim/practitionerRow'
import NewPractitioner from '../../../widgets/SubmitAClaim/newPractitioner'
import RBButton from '../../../controls/RBButton'
import Drawer from '@material-ui/core/Drawer'
import AddClinicForm from '../../../widgets/SubmitAClaim/AddClinicForm'
import AddPractitionerForm from '../../../widgets/SubmitAClaim/AddPractitionerForm'
import SubmitEmptyState from '../../../widgets/SubmitAClaim/SubmitEmptyState'
import { withStyles } from '@material-ui/core/styles'
import { ClaimTypes } from '../../../redux/SubmitClaim/Common'
import CardStyles from '../../../styles/cards'

// redux
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import {
  postClinic,
  fetchInitalPractitioners,
  searchPractitioners,
  deletePreviouslyUsedPractitioner,
  editClinic,
  setSelectedPractioner,
  clearSelectedPractioner,
  postPractitioner
} from '../../../redux/actions/submitPractitionerActions'

import Loading from '../../../widgets/Loading'
import { passMessage, passNavCallbacks, goNext } from '../../../redux/actions/submitNavigationActions'
import { getSearchTitle, getPractitionerTitle } from './functions'

const photoUpload = 'photoUpload'
const addPracModel = {
  open: false,
  shouldRenderDrawer: false,
  newPractitioner: {}
}

class Practitioner extends Component {
  constructor (props) {
    super(props)

    this.changeNext = this.changeNext.bind(this)
    this.renderPrevPractitioners = this.renderPrevPractitioners.bind(this)
    this.renderSearchedPractitioners = this.renderSearchedPractitioners.bind(this)
    this.setSearched = this.setSearched.bind(this)
    this.openAddEditNewClinic = this.openAddEditNewClinic.bind(this)
    this.addNew = this.addNew.bind(this)
    this.hideAddNewClinic = this.hideAddNewClinic.bind(this)
    this.renderNewClinic = this.renderNewClinic.bind(this)
    this.deleteNewClinic = this.deleteNewClinic.bind(this)
    this.updateClaim = this.updateClaim.bind(this)
    this.hideeditPreviousClinic = this.hideeditPreviousClinic.bind(this)
    this.editPreviousClinic = this.editPreviousClinic.bind(this)
    this.editPreviousClinicDone = this.editPreviousClinicDone.bind(this)

    const { claimObj = {}, benefitTypes = [] } = props
    const { claimSubmitType = null } = claimObj

    this.state = {
      phone: '',
      postalCode: '',
      practitioner: null,
      searched: false,
      claimSubmitType,
      originalClaimSubmitType: props.claimObj.claimSubmitType,
      screenWidth: window.innerWidth > 500 ? 490 : 300,
      editExistingClinicState: {
        open: false,
        shouldRenderDrawer: false,
        clinic: {}
      },
      addExistingClinicState: {
        open: false,
        shouldRenderDrawer: false,
        newClinic: {}
      },
      addExistingPractitionerState: {
        ...addPracModel
      },
      hadPhotoUploadAtMount: false,
      hasSelectedAddedPractitioner: false,
      practitionerTitle: getPractitionerTitle(claimObj.type, benefitTypes),
      searchTitle: getSearchTitle(claimObj.type, benefitTypes)
    }
  }

  componentDidMount () {
    this.props.fetchInitalPractitioners(this.props.claimObj.searchName)

    this.props.updateUrl(null)
    this.props.setNext(null)
    this.props.setPercent(50)

    // We need to track whether or not we had photos at mount to be able to
    // keep the empty state component visible after removing previously selected
    // files. `state.hadPhotoUploadAtMount` should be set to `false` when the user
    // searches practitioners.
    this.setState({ hadPhotoUploadAtMount: this.hasPhotoUpload() }, this.changeNext)
  }

  componentDidUpdate (prevProps) {
    const { dialogRsp, claimObj = {} } = this.props
    const { claimObj: prevClaimObj = {} } = prevProps

    if ((dialogRsp !== prevProps.dialogRsp) && (dialogRsp === true || dialogRsp === false)) {
      this.props.goNext()
    } else if (claimObj.claimType !== prevClaimObj.claimType) {
      this.changeNext()
    }

    this.updatePractitionerTitle()
    this.updateSearchTitle()
  }

  static getDerivedStateFromProps (props, state) {
    const { claimObj = {} } = props
    const { claimSubmitType } = claimObj

    if (claimSubmitType !== state.claimSubmitType) {
      return { claimSubmitType }
    } else {
      return null
    }
  }

  updatePractitionerTitle () {
    const { claimObj = {}, benefitTypes = [] } = this.props
    const practitionerTitle = getPractitionerTitle(claimObj.type, benefitTypes)

    if (practitionerTitle !== this.state.practitionerTitle) {
      this.setState({ practitionerTitle })
    }
  }

  updateSearchTitle () {
    const { claimObj = {}, benefitTypes = [] } = this.props
    const searchTitle = getSearchTitle(claimObj.type, benefitTypes)

    if (searchTitle !== this.state.searchTitle) {
      this.setState({ searchTitle })
    }
  }

  initalEmptyState () {
    const hasPractitioners = this.hasPractitioners()
    const hasInitialPractitioners = this.hasInitialPractitioners()
    const hasNewPractitioner = this.hasNewPractitioner()
    const hasNewClinic = this.hasNewClinic()

    if (this.props.isLoading === false && this.state.searched === false && !hasPractitioners && !hasInitialPractitioners && !hasNewPractitioner && !hasNewClinic) {
      return (
        <Row center='xs'>
          <Col xs={12}>
            <br /><br />
            <p>{localize('pages.SubmitAClaim.Practitioner.noPrevPractitioners')}</p>
          </Col>
        </Row>
      )
    }
  }

  openAddEditNewClinic () {
    const addExisting = ClaimTypes.isEHCOther(this.props.claimObj.type) ? 'addExistingClinicState' : 'addExistingPractitionerState'
    this.setState({ [`${addExisting}`]: { ...this.state[`${addExisting}`], shouldRenderDrawer: true } }, () => {
      setTimeout(() => {
        this.setState({ [`${addExisting}`]: { ...this.state[`${addExisting}`], open: true } })
      })
    })
  }

  hideAddNewClinic () {
    const addExisting = ClaimTypes.isEHCOther(this.props.claimObj.type) ? 'addExistingClinicState' : 'addExistingPractitionerState'
    const addExistingPrac = this.state.addExistingPractitionerState
    this.setState({ [`${addExisting}`]: { ...this.state[`${addExisting}`], open: false } }, () => {
      setTimeout(() => this.setState({ [`${addExisting}`]: { ...this.state[`${addExisting}`], shouldRenderDrawer: false } }))
    })

    if (addExisting === 'addExistingPractitionerState' && addExistingPrac.newPractitioner && addExistingPrac.newPractitioner.clinicName) {
      this.selectPractitioner(this.state.addExistingPractitionerState.newPractitioner, true)
    }
  }

  addNew (clinic) {
    const addExisting = ClaimTypes.isEHCOther(this.props.claimObj.type) ? 'addExistingClinicState' : 'addExistingPractitionerState'
    const newObj = ClaimTypes.isEHCOther(this.props.claimObj.type) ? 'newClinic' : 'newPractitioner'
    this.setState({ [`${addExisting}`]: { ...this.state[`${addExisting}`], [`${newObj}`]: clinic }, searched: false }, this.hideAddNewClinic)
  }

  hasPhotoUpload () {
    return (this.claimFiles().length > 0)
  }

  hasPractitioners () {
    return (this.props.practitioners && this.props.practitioners.length > 0)
  }

  hasInitialPractitioners () {
    return (this.props.initialPractitioners && this.props.initialPractitioners.length > 0)
  }

  hasNewPractitioner () {
    return (Object.keys(this.state.addExistingPractitionerState.newPractitioner || {}).length > 0)
  }

  hasNewClinic () {
    return (Object.keys(this.state.addExistingClinicState.newClinic || {}).length > 0)
  }

  claimFiles () {
    if (this.props.claimObj) {
      return this.props.claimObj.ImageContent || []
    } else {
      return []
    }
  }

  searchEmptyState () {
    const { hadPhotoUploadAtMount } = this.state
    const hasPhotoUpload = this.hasPhotoUpload()
    const hasPractitioners = this.hasPractitioners()
    const hasInitialPractitioners = this.hasInitialPractitioners()
    const hasNewPractitioner = this.hasNewPractitioner()
    const hasNewClinic = this.hasNewClinic()

    if (this.props.isLoading === false && ((this.state.searched === true && !hasPractitioners) || hasPhotoUpload || hadPhotoUploadAtMount)) {
      return (
        <div>
          <SubmitEmptyState
            practitionerTitle={this.state.practitionerTitle}
            practitioners={this.props.practitioners}
            reason={(ClaimTypes.isDental(this.props.claimObj.type) || ClaimTypes.isDrug(this.props.claimObj.type)) ? 'notFound' : 'notFoundPrac'}
            addPractitioner={() => this.openAddEditNewClinic('prac')}
            memberSummary={this.props.memberSummary}
            type={this.props.type}
            setNext={this.props.setNext}
            updateClaim={this.updateClaim}
            next={'certifcationAndAuthorization'}
            passMessage={this.props.passMessage}
            dialogRsp={this.props.dialogRsp}
            initialFileList={this.claimFiles()}
            clinicName={this.state.addExistingPractitionerState.newPractitioner.clinicName}
          />
          <br /><br />
          {(hasInitialPractitioners || hasPractitioners || hasNewPractitioner || hasNewClinic) ? <Divider /> : null}
        </div>
      )
    } else {
      return null
    }
  }

  renderPrevPractitioners () {
    if (this.props.isLoading === true) {
      return null
    }

    if (this.hasInitialPractitioners()) {
      const { practitionerTitle } = this.state
      const canEdit = this.props.claimObj ? ClaimTypes.isEHCOther(this.props.claimObj.type) : false
      let titleLabel = localize('pages.SubmitAClaim.Practitioner.previouslyUsed')
      if (!(/\s+$/.test(titleLabel))) {
        titleLabel = `${titleLabel} ${practitionerTitle}`
      } else {
        titleLabel = `${titleLabel}${practitionerTitle}`
      }

      const { classes = {} } = this.props

      return (
        <Row start='xs'>
          <Row>
            <Col className={classes.summaryCard}>
              <p className='titledLabelTitle'>{titleLabel}</p>
            </Col>
          </Row>
          <Col xs={12}>
            {this.props.initialPractitioners.map((p, i) => {
              return (
                p.error
                  ? <p className='error-message'>{p.error}</p>
                  : <PractitionerRow
                    onClick={() => this.selectPractitioner(p)}
                    key={i} p={p}
                    practitioner={this.state.practitioner || this.props.claimObj}
                    canDelete
                    type={this.props.claimObj.type}
                    isSelected={this.state.practitioner && this.state.practitioner.clinicId === p.clinicId}
                    delete={() => this.deletePreviousClinic(p)}
                    edit={canEdit ? () => this.editPreviousClinic(p) : undefined} />
              )
            })}
          </Col>
        </Row>
      )
    }
  }

  renderSearchedPractitioners () {
    const { classes = {} } = this.props

    if (this.props.isLoading === false && this.hasPractitioners()) {
      return (
        <Row start='xs'>
          <Row>
            <Col className={classes.summaryCard}>
              <p className='titledLabelTitle'>
                {localize('pages.SubmitAClaim.Practitioner.SelectYour')} {this.state.practitionerTitle} {localize('pages.SubmitAClaim.Practitioner.Clinic')}
              </p>
            </Col>
          </Row>
          <Col xs={12}>
            {this.props.practitioners.map((p, i) => {
              return (
                p.error
                  ? <p className='error-message'>{p.error}</p>
                  : <PractitionerRow
                    onClick={() => this.selectPractitioner(p, true)}
                    key={i}
                    p={p}
                    canDelete={false}
                    isSelected={this.state.practitioner && this.state.practitioner.firstName === p.firstName && this.state.practitioner.lastName === p.lastName && this.state.practitioner.clinicName === p.clinicName}
                    practitioner={this.state.practitioner || this.props.claimObj} />
              )
            })}
          </Col>
        </Row>
      )
    } else {
      return null
    }
  }

  selectPractitioner (practitioner, isNewClinic = false) {
    const hasSelectedAddedPractitioner = (practitioner === this.state.addExistingPractitionerState.newPractitioner)
    const claimObj = { ...this.props.claimObj }

    if (practitioner) {
      claimObj.claimSubmitType = 'onlineSubmit'
      claimObj.ImageContent = []

      this.props.updateClaim(claimObj)
      this.props.setSelectedPractioner(
        this.props.claimObj && this.props.claimObj.type,
        isNewClinic,
        practitioner)
    } else {
      this.props.clearSelectedPractioner()
    }

    this.setState({
      practitioner,
      hasSelectedAddedPractitioner
    }, () => this.changeNext())
  }

  changeNext () {
    if (this.state.claimSubmitType === photoUpload) {
      this.props.setNext('certifcationAndAuthorization')
    } else if (!this.state.practitioner && !this.props.claimObj.RegistrationNumber) {
      this.props.setNext(null)
    } else {
      const claimObj = { ...this.props.claimObj }
      this.props.passMessage(null)
      this.props.setNext(claimObj.claimType === 'hcsaClaim' ? 'expense' : 'claimExpense')
      // We should only post the new practitioner if it is set on the claim. We know this
      // is true if this.state.hasSelectedAddedPractitioner === true. We can't assume that we
      // should use the new practitioner just becasue it is set on the component state becasue
      // the claimant could switch back to a previously used practitioner or a search result.
      if (claimObj.type !== 'Other Extended Health' && this.state.hasSelectedAddedPractitioner) {
        this.props.passNavCallbacks({
          onNext: {
            callback: (onComplete) => this.props.postPractitioner(this.state.addExistingPractitionerState.newPractitioner, this.props.claimObj.searchName, () => {
              this.props.goNext()
              onComplete()
            }),
            async: true
          }
        })
      }
    }
  }

  setSearched () {
    this.setState({
      searched: true,
      hadPhotoUploadAtMount: false
    })
  }

  updateClaim (updates = {}) {
    const { claimSubmitType = null } = updates
    const claimObj = { ...this.props.claimObj, ...updates }

    this.setState({ claimSubmitType }, () => {
      if (claimSubmitType === photoUpload) {
        this.selectPractitioner(null)
      } else {
        this.changeNext()
      }
    })

    this.props.updateClaim(claimObj)
  }

  renderNewClinic () {
    if (this.props.isLoading) {
      return null
    }

    if (this.hasNewClinic()) {
      if (this.state.addExistingClinicState.newClinic.clinicName) {
        return (
          <div>
            <br />
            <PractitionerRow
              onClick={() => this.selectPractitioner(this.state.addExistingClinicState.newClinic, true)}
              practitioner={this.state.practitioner || this.props.claimObj}
              type={this.props.claimObj.type}
              newClaim={this.state.addExistingClinicState.newClinic}
              canDelete
              delete={() => this.deleteNewClinic()}
              edit={() => this.openAddEditNewClinic()} />
          </div>
        )
      }
    }

    if (this.hasNewPractitioner()) {
      if (this.state.addExistingPractitionerState.newPractitioner.firstName) {
        return (
          <div>
            <br />
            <NewPractitioner
              onClick={() => this.selectPractitioner(this.state.addExistingPractitionerState.newPractitioner, true)}
              practitioner={this.state.practitioner || this.props.claimObj}
              type={this.props.claimObj.type}
              newPrac={this.state.addExistingPractitionerState.newPractitioner}
              canDelete
              delete={() => this.setState({
                practitioner: null,
                addExistingPractitionerState: { ...addPracModel }
              }, () => this.changeNext())}
              edit={() => this.openAddEditNewClinic()}
              isSelected={this.state.practitioner}
            />
          </div>
        )
      }
    }

    return null
  }

  deleteNewClinic () {
    if (ClaimTypes.isEHCOther(this.props.claimObj.type)) {
      if (this.state.addExistingClinicState.newClinic && this.state.addExistingClinicState.newClinic.clinicId) {
        this.props.clearSelectedPractioner()
        this.props.deletePreviouslyUsedPractitioner(this.state.addExistingClinicState.newClinic.clinicId, () => {
          this.setState({
            practitioner: null,
            addExistingClinicState: {
              newClinic: {
                clinicName: '',
                phone: '',
                address: '',
                city: '',
                province: 'ON',
                provValue: 'ON',
                postalCode: ''
              }
            }
          }, () => this.changeNext())
        })
      }
    } else { // if it's a new practitioner rather than
      this.props.clearSelectedPractioner()
      this.props.deletePreviouslyUsedPractitioner(this.state.addExistingClinicState.newClinic.clinicId, () => {
        this.setState({
          practitioner: null,
          addExistingPractitionerState: {
            newPractitioner: {}
          }
        }, () => this.changeNext())
      })
    }
  }

  deletePreviousClinic (e) {
    if (e.clinicId) {
      this.props.deletePreviouslyUsedPractitioner(e.clinicId, () => {
        this.props.clearSelectedPractioner()
        this.props.fetchInitalPractitioners(this.props.claimObj.searchName)
        this.setState({ practitioner: null }, () => this.changeNext())
      })
    }
  }

  editPreviousClinic (e) {
    // only applies to ehc other
    if (e.clinicId) {
      this.setState({ editExistingClinicState: { ...this.state.editExistingClinicState, shouldRenderDrawer: true, clinic: e } }, () => {
        setTimeout(() => {
          this.setState({ editExistingClinicState: { ...this.state.editExistingClinicState, open: true } })
        })
      })
    }
  }

  editPreviousClinicDone (clinic) {
    if (clinic) {
      this.setState({ editExistingClinicState: { ...this.state.editExistingClinicState, open: false } }, () => {
        setTimeout(() => {
          this.setState({ editExistingClinicState: { ...this.state.editExistingClinicState, shouldRenderDrawer: false } })
          this.props.fetchInitalPractitioners(this.props.claimObj.searchName)
        })
      })
    }
  }

  hideeditPreviousClinic () {
    this.setState({ editExistingClinicState: { ...this.state.editExistingClinicState, open: false } }, () => {
      setTimeout(() => {
        this.setState({ editExistingClinicState: { ...this.state.editExistingClinicState, shouldRenderDrawer: false } })
      })
    })
  }

  render () {
    // TODO: Navigation actions should not be performed in render.
    // This should be moved out to componentDidMount or componentDidUpdate.
    if (!NgrxAuth.canSubmitClaim) {
      this.props.push('/Claims')
    }

    const openDrawer = ClaimTypes.isEHCOther(this.props.claimObj.type) ? this.state.addExistingClinicState.shouldRenderDrawer : this.state.addExistingPractitionerState.shouldRenderDrawer
    const openForm = ClaimTypes.isEHCOther(this.props.claimObj.type) ? this.state.addExistingClinicState.open : this.state.addExistingPractitionerState.open

    const openEditDrawer = ClaimTypes.isEHCOther(this.props.claimObj.type) ? this.state.editExistingClinicState.shouldRenderDrawer : false
    const openEditForm = ClaimTypes.isEHCOther(this.props.claimObj.type) ? this.state.editExistingClinicState.open : false

    return (
      <Card className='submitCard'>
        <Row start='xs'>
          <Col xs={12}>
            <h3>{this.state.searchTitle}</h3>
            <Row center='xs' end='md' middle='xs'>
              <Col xs={12} sm={12} md={4} lg={4}>
                <p style={{ textAlign: 'left' }} className='policyNum'>{localize('pages.SubmitAClaim.Patient')}: <span style={{ fontWeight: 300 }}>{this.props.claimObj.Patient}</span></p>
              </Col>
              <Col xs={12} sm={10} md={8} lg={8}>
                {this.props.claimObj.categoryCode === ''
                  ? <RBButton
                    label={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.AddNewClinicButton')}
                    variant='contained'
                    primary
                    onClick={() => this.openAddEditNewClinic()}
                    disabled={!!this.state.addExistingClinicState.newClinic.clinicName} />
                  : <SearchPractitioner searchPractitioners={this.props.searchPractitioners} type={this.props.claimObj.searchName} categoryCode={this.props.claimObj.categoryCode} setSearched={this.setSearched} />}
              </Col>
            </Row>
            <br />
            <Divider />
            {this.props.isLoading ? <Loading /> : null}
            {this.initalEmptyState()}
            {this.searchEmptyState()}
            {this.renderNewClinic()}
            {this.renderSearchedPractitioners()}
            {this.renderPrevPractitioners()}
          </Col>
        </Row>
        {openDrawer
          ? <Row>
            <Col xs={12}>
              <Drawer
                style={{ width: this.state.screenWidth }}
                anchor='right'
                open={openForm}
              >
                {this.props.claimObj.categoryCode === ''
                  ? <AddClinicForm
                    addClinic={this.addNew}
                    type={this.props.claimObj.searchName}
                    onCancel={() => this.hideAddNewClinic('clinic')}
                    postClinic={this.props.postClinic}
                    editClinic={this.props.editClinic}
                    newClinic={this.state.addExistingClinicState.newClinic}
                    edit={!!this.state.addExistingClinicState.newClinic.clinicName}
                  />
                  : <AddPractitionerForm
                    practitionerTitle={this.state.practitionerTitle}
                    addClinic={this.addNew}
                    type={this.props.claimObj.searchName}
                    onCancel={() => this.hideAddNewClinic('prac')}
                    postPractitioner={this.props.postPractitioner}
                    editClinic={this.props.editClinic}
                    newPractitioner={this.state.addExistingPractitionerState.newPractitioner}
                    edit={!!this.state.addExistingPractitionerState.newPractitioner.clinicName}
                  />}
              </Drawer>
            </Col>
          </Row> : null}
        {openEditDrawer
          ? <Row>
            <Col xs={12}>
              <Drawer
                style={{ width: this.state.screenWidth }}
                anchor='right'
                open={openEditForm}
              >
                <AddClinicForm
                  addClinic={this.editPreviousClinicDone}
                  type={this.props.claimObj.ClinicType}
                  onCancel={() => this.hideeditPreviousClinic('clinic')}
                  editClinic={this.props.editClinic}
                  newClinic={this.state.editExistingClinicState.clinic}
                  edit={!false} // had to use !false to set to true b/c setting to true caused an JSX warning, no clue why but should be fixed (MA)
                />
              </Drawer>
            </Col>
          </Row> : null}
      </Card>
    )
  }
}

function mapStateToProps (state) {
  const { benefitTypes = [] } = (state.SubmitExpenseReducer.benefitTypes || {})
  return {
    isLoading: state.SubmitPractitionerReducer.isLoading || false,
    initialPractitioners: state.SubmitPractitionerReducer.initialPractitioners || null,
    error: state.SubmitPractitionerReducer.error || null,
    practitioners: state.SubmitPractitionerReducer.practitioners,
    claimObj: state.SubmitAClaimReducer.claimObj,
    dialogRsp: state.SubmitNavigationReducer.dialogRsp,
    memberSummary: state.memberSummaryReducer.memberSummary,
    callBacks: state.SubmitNavigationReducer.callBacks,
    pageNext: state.SubmitNavigationReducer.pageNext,
    pracLoading: state.SubmitPractitionerReducer.pracLoading,
    pracResponse: state.SubmitPractitionerReducer.pracResponse,
    pracError: state.SubmitPractitionerReducer.pracError,
    benefitTypes
  }
}

const ConnectedPractitioner = connect(mapStateToProps, {
  editClinic,
  postPractitioner,
  postClinic,
  fetchInitalPractitioners,
  searchPractitioners,
  deletePreviouslyUsedPractitioner,
  setSelectedPractioner,
  clearSelectedPractioner,
  passMessage,
  passNavCallbacks,
  goNext
})(injectIntl(Practitioner))

const styles = {
  ...CardStyles
}

export default withStyles(styles)(ConnectedPractitioner)



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/Practitioner/index.js